/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/todoist" */ '@atlassian/logo-third-party/todoist'
		).then((m) => m.TodoistIcon),
	{ moduleId: '@atlassian/logo-third-party/todoist' },
);

const LazyTodoistIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-todoist" */ './utils').then((m) => m.TodoistIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/todoist/icon' },
);

const LazyTodoistSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-todoist-search-result" */ './utils').then(
			(m) => m.TodoistSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/todoist/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const TodoistIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyTodoistIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const TodoistSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyTodoistSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
